import Vue from 'vue';
import Vuex from 'vuex';
import authentication from './modules/authentication';
import projects from './modules/projects';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        authentication,
        projects,
    },
});
